import React from 'react';
import PropTypes from 'prop-types';
import { ButtonWithIcon } from '@els/els-react--button';
import { EXPORT_TAB_RESULT_STATUSES } from '../ExportTabConstants';

import './ExportTabTooltipFooter.scss';

function ExportTabTooltipFooter(props) {
  const { exportResult, cancel, retry, retryDisabled, downloadByURL } = props;
  const { status } = exportResult;

  return (
    <div className="exportTab__tooltip_footer">
      {status === EXPORT_TAB_RESULT_STATUSES.FINISHED && (
        <ButtonWithIcon
          data-e2e="export-tab-download"
          type="link"
          size="small"
          sprite="ChevronRight"
          iconRight
          onClick={downloadByURL}
          className="e2e-export-tab-download">
          Download
        </ButtonWithIcon>
      )}

      <ButtonWithIcon
        data-e2e="export-tab-cancel"
        type="link"
        size="small"
        sprite="ChevronRight"
        iconRight
        onClick={() => cancel()}
        className="u-els-margin-left-1o2 e2e-export-tab-cancel">
        Cancel
      </ButtonWithIcon>

      {status === EXPORT_TAB_RESULT_STATUSES.CONNECTION_ERROR && (
        <ButtonWithIcon
          data-e2e="export-tab-retry"
          type="link"
          size="small"
          sprite="ChevronRight"
          iconRight
          onClick={retry}
          disabled={retryDisabled}
          className="e2e-export-tab-retry">
          Retry
        </ButtonWithIcon>
      )}
    </div>
  );
}

ExportTabTooltipFooter.propTypes = {
  exportResult: PropTypes.object,
  retryDisabled: PropTypes.bool,
  cancel: PropTypes.func.isRequired,
  retry: PropTypes.func.isRequired,
  downloadByURL: PropTypes.func.isRequired,
};

export default ExportTabTooltipFooter;
